import { uploadImage } from "../../../utils/UploadImage";

export async function uploadFirmLogo(
  firmId: string,
  logo: string | File | null,
): Promise<string> {
  if (typeof logo === "string") {
    return logo;
  }

  if (logo instanceof File) {
    const uploaded = await uploadImage(logo, firmId, "firm/logos/");
    if (!uploaded) {
      throw new Error("Failed to upload logo.");
    }
    return uploaded;
  }

  return "";
}
